import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AdminService } from '../../../service/admin.service';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';
import { PrimengImports } from '../../../shared/primeng-imports';

@Component({
  selector: 'app-admin-login',
  imports: [CommonModule, LucideIconsModule, ReactiveFormsModule, PrimengImports, FormsModule,RouterLink],
  templateUrl: './admin-login.component.html',
  styleUrl: './admin-login.component.css',
  providers: [MessageService]
})
export class AdminLoginComponent {
  showPassword = false;
  loading = false;
  loginForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    private router: Router,
    private messageService: MessageService
  ) {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  async onSubmit() {
    if (this.loginForm.invalid) {
      return;
    }
    this.loading = true;
    try {
      const formValues = this.loginForm.value;
      this.adminService.login(formValues.email, formValues.password).subscribe({
        next: (response) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Admin signed in successfully!', life: 3000 });
          setTimeout(() => {
            this.router.navigate(['/admin']);
          }, 500);
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message || 'An error occurred. Please try again.', life: 3000 });
        },
        complete: () => {
          this.loading = false;
        }
      });
      return;
    } catch (err: any) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message || 'An error occurred. Please try again.', life: 3000 });
    } finally {
      this.loading = false;
    }
  }
}
